import Vue from "vue";
import Vuex from "vuex";

// modules
import auth from "@/store/modules/auth";
import bannerCarousel from '@/store/modules/bannerCarousel'
import cart from "@/store/modules/cart";
import category from "@/store/modules/category";
import department from "@/store/modules/department";
import departments from "@/store/modules/departments";
import error from "@/store/modules/error";
import favorites from "@/store/modules/favorites";
import loader from "@/store/modules/loader";
import menu from "@/store/modules/menu";
import notification from "@/store/modules/notification";
import orders from "@/store/modules/orders";
import orderStatus from "@/store/modules/orderStatus";
import popular from "@/store/modules/popular";
import product from "@/store/modules/product";
import promotion from "@/store/modules/promotion";
import promotions from "@/store/modules/promotions";
import search from "@/store/modules/search";
import store from "@/store/modules/store";
import template from '@/store/modules/template';
import user from "@/store/modules/user";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    cart,
    bannerCarousel,
    category,
    department,
    departments,
    error,
    favorites,
    loader,
    menu,
    notification,
    orders,
    orderStatus,
    popular,
    product,
    promotion,
    promotions,
    search,
    store,
    template,
    user,
  },
});
